import { urlKaitenInfo } from "./services-urls";
import {KaitenOutputData} from '../../../../KaitenServer/src/DataSource/DataSet/dataset';

export default class SystemServicesController {

    public static async getKaitenInfo(): Promise<KaitenOutputData> {
        const URL: string = urlKaitenInfo;
        try {
            const header: any = {
                method: 'GET',
                cache: 'no-cache',
                headers: {
                    'Content-Type':'application/json; charset=utf-8',
                }
            }
            return await fetch(URL , header)
                .then (this.handledHTTPResponse)
                .then (this.validationJSON);
        } catch(e: any) {
            throw new Error (`Fetch Error: ${e.message}`);
        }
    }

    private static handledHTTPResponse (response: any) {
        if (response.status === 404) throw new Error ('Url not found');
        return response.text();
    }

    private static validationJSON (data: any): any {
        try {
            const result = JSON.parse(data);
            return result.data;
        } catch (e) {
            throw new Error ('Invalid JSON');
        }
    }
}